import React from 'react';

interface NavigationItemProps {
  icon: React.ReactNode;
  label: string;
  isActive: boolean;
  onClick: () => void;
  isExpanded: boolean;
  badge?: string;
}

const NavigationItem: React.FC<NavigationItemProps> = ({ 
  icon, 
  label, 
  isActive, 
  onClick, 
  isExpanded, 
  badge 
}) => {
  return (
    <button
      onClick={onClick}
      className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-left transition-all duration-200 group relative ${
        isActive 
          ? 'text-[#40e0d0]' 
          : 'hover:bg-muted/50 text-muted-foreground hover:text-foreground'
      }`}
      title={!isExpanded ? label : undefined}
    >
      {/* Active indicator */}
      {isActive && (
        <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-8 bg-gradient-to-b from-[#40e0d0] to-emerald-500 rounded-r-full" />
      )}
      
      {/* Icon */}
      <div className={`flex-shrink-0 ${
        isActive ? 'text-[#40e0d0]' : 'text-muted-foreground group-hover:text-foreground'
      } transition-colors`}>
        {icon}
      </div>
      
      {/* Label */}
      <span className={`font-medium transition-all duration-200 ${
        isExpanded ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-2'
      } ${
        isActive ? 'text-[#40e0d0]' : 'text-inherit'
      }`}>
        {label}
      </span>
      
      {/* Badge */}
      {badge && isExpanded && (
        <div className={`ml-auto flex-shrink-0 px-2 py-1 rounded-full text-xs font-medium transition-all duration-200 ${
          isActive 
            ? 'bg-[#40e0d0] text-white' 
            : 'bg-muted text-muted-foreground'
        }`}>
          {badge}
        </div>
      )}
    </button>
  );
};

export default NavigationItem;